import { View } from '@shared/components/View';
import { MBAnimation } from '@shared/components/animation';
import { MBActionButtons } from '@shared/scenes/chat/thread/containers/messageActionButtons';
import { grid } from '@shared/styles';
import { API } from '@shared/types/api';

interface MessageHoverContentProps {
  showContent: boolean;
  align: 'left' | 'right';
  message: API.ChatMessageFragment;
  channelSlug: string;
  includeEdit?: boolean;
  reactionPickerAnchorName: string;
}
export function MessageHoverContent({
  showContent,
  align,
  message,
  channelSlug,
  includeEdit = true,
  reactionPickerAnchorName,
}: MessageHoverContentProps) {
  return (
    <View
      relative
      style={{
        flexShrink: 1,
        flexGrow: 0,
        height: '100%',
        justifyContent: 'center',
        pointerEvents: showContent ? 'auto' : 'none',
      }}
    >
      <MBAnimation
        style={{
          flexShrink: 0,
          flexGrow: 1,
          height: '100%',
          justifyContent: 'center',
          alignItems: align === 'right' ? 'flex-end' : 'flex-start',
          marginRight: align === 'right' ? grid(0.5) : 0,
          marginLeft: align === 'left' ? grid(1) : grid(0.5),
        }}
        duration={300}
        disabled={!showContent}
        opacity={{ from: 0, to: 1 }}
      >
        <View
          style={{
            flexShrink: 0,
            flexGrow: 1,
            height: '100%',
            justifyContent: 'center',
          }}
        >
          <MBActionButtons
            message={message}
            channelSlug={channelSlug}
            isHovering
            includeEdit={includeEdit}
            reactionPickerAnchorName={reactionPickerAnchorName}
          />
        </View>
      </MBAnimation>
    </View>
  );
}
